import React from 'react';
import _ from 'lodash';

export function getDestructuredText(text, link) {
    const destructuredText = destructureLinkedText(text);

    return (
        <p>
            {destructuredText.firstPartOfText}
            <a className='link' href={link} target='_blank' rel='noopener noreferrer'>
                {destructuredText.linkPartOfText}
            </a>
            {destructuredText.secondPartOfText}
        </p>
    );
}

export function getDestructuredTextWithMultipleLinks(text, links) {
    const textForLinks = text.match(/\[(.*?)\]/g) || [];
    let destructuredText = text;

    for (let i = 0; i < textForLinks.length; i++) {
        const linkTag = `<a class='link' href=${links[i]} target='_blank' rel='noopener noreferrer'>
            ${textForLinks[i].replace('[', '').replace(']', '')}
        </a>`;

        destructuredText = destructuredText.replace(textForLinks[i], linkTag);
    }

    return (
        <p dangerouslySetInnerHTML={{ __html: destructuredText }} />
    );
}

function destructureLinkedText(text) {
    const firstIndex = text.indexOf('[');
    const lastIndex = text.indexOf(']');

    const firstPartOfText = text.substring(0, firstIndex);
    const linkPartOfText = text.substring(firstIndex + 1, lastIndex);
    const secondPartOfText = text.substring(lastIndex + 1, text.length);

    return { firstPartOfText, linkPartOfText, secondPartOfText };
}

export function getMultilineText(text) {
    if (_.isEmpty(text)) {
        return [];
    }

    return text.split('\n');
}

export function removeSpaces(text) {
    return text.replace(/ /g, '');
}

export function toCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, camelCase).replace(/\s+/g, '');
}

function camelCase(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
}

export function getInitials(firstName, lastName) {
    return `${firstName[0]}${lastName[0]}`;
}

export function getTitleLabel(titleCode, titleOptions) {
    const titleOption = titleOptions.find((x) => x.code === titleCode);

    if (!titleOption) {
        return '';
    }

    return titleOption.label;
}
